<template>
    <div :style="'width:' + width/1920*100 + 'vw;height:' + height/870*100 + 'vh'" class="bg">
        <div class="detailBody">
            <div class="title">
                <div>{{currentLoop[0].loopName}}1</div>
                <img src="@/assets/img/关闭.png" alt="" @click="$emit('closeLoopDetail')">
            </div>
            <div class="tab" id="diagramTab">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="电力数据" name="电力数据">电力数据</el-tab-pane>
                    <el-tab-pane v-if="areaId == 22" label="控制" name="控制">控制</el-tab-pane>
                    <el-tab-pane v-if="areaId == 22" label="分合历史" name="分合历史">分合历史</el-tab-pane>
                </el-tabs>
            </div>
            <div class="table" id="diagramTable" v-show="activeName == '电力数据'">
                <el-table v-if="tableData.length > 0" :data="tableData" border style="width: 100%;height:100%"
                    :header-cell-style="{padding: '0'}" :header-row-style="{ height: 400/108 + 'vh' }"
                    :row-style="{ height: 400/108 + 'vh' }" :cell-style="{ padding: '0' }" height="100%">
                    <el-table-column fixed align="center" prop="node" label="参数名称">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="realValue" label="实时数据">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="max" label="当日最大值">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="max_time" label="最大值时间">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="min" label="当日最小值">
                    </el-table-column>
                    <el-table-column fixed align="center" prop="min_time" label="最小值时间">
                    </el-table-column>
                </el-table>

                <div v-else class="row-center tip">
                    <img src="@/assets/img/loading.png" alt="" class="loading">
                </div>
            </div>
            <div v-show="activeName == '控制'" style="min-height: 450rem;">
                <div class="control">
                    <div class="circleload" v-if="circleloadStatus">
                        <CircleLoad :originCountDown="5" />
                    </div>
                    <div class="state" v-if="!circleloadStatus && !errorstatus">
                        <div>
                            <div style="margin-bottom:30rem">控制状态:
                                <span style="margin-left:20rem">{{distantstatus}}</span>
                            </div>
                            <div>回路状态:
                                <span style="margin-left:20rem"
                                    :style="'color:' + (state == '合闸' ? 'red' : state == '分闸' ? 'green' : '#000')">{{state}}</span>
                            </div>
                        </div>
                        <div v-if="distantstatus == '远方'">
                            <div class="control_btn" style="margin-bottom:20rem"
                                :style="state == '合闸' ? 'cursor: not-allowed;background: #999;' : ''"
                                @click="state == '合闸' ? handleClick(false) : handleClick(true)">
                                申请合闸
                            </div>
                            <div class="control_btn"
                                :style="state == '分闸' ? 'cursor: not-allowed;background: #999;' : ''"
                                @click="state == '分闸' ? handleClick(false) : handleClick(true)">
                                申请分闸
                            </div>
                        </div>
                        <div v-else>
                            <div class="control_btn" style="cursor: not-allowed;background: #999;margin-bottom:20rem">
                                申请合闸
                            </div>
                            <div class="control_btn" style="cursor: not-allowed;background: #999;">
                                申请分闸
                            </div>
                        </div>
                    </div>
                    <div class="state" v-if="!circleloadStatus && errorstatus">
                        <div>
                            <div style="margin-bottom:30rem;display:flex;align-items:center">控制状态:
                                <span style="margin-left:20rem">--</span>
                                <div class="control_btn" style="cursor: not-allowed;background: #999;margin-left:30rem">
                                    申请合闸
                                </div>
                            </div>
                            <div style="margin-bottom:30rem;display:flex;align-items:center">回路状态:
                                <span style="margin-left:20rem">--</span>

                                <div class="control_btn" style="cursor: not-allowed;background: #999;margin-left:30rem">
                                    申请分闸
                                </div>
                            </div>

                            <div style="width:200rem;display:flex;align-items:center;justify-content:space-around"
                                v-if="errorstatus">
                                <img src="@/assets/img/looperror.png" alt="">故障状态
                            </div>
                        </div>
                    </div>
                    <div class="popup" v-show="popup">
                        <div class="firstLine">
                            <img class="icon" src="../../assets/img/提示ICON.png" />
                            <div style="line-height:33rem">将“{{currentLoop[0].loopName}}”状态改为“
                                <span
                                    :style="'color:' + (state == '合闸' ? 'green' : 'red')">{{state == '合闸' ? '分闸' : '合闸'}}</span>”
                            </div>
                        </div>
                        <div class="secondLine">
                            <div style="display:flex">
                                <span>请输入右侧验证码</span>
                                <input v-model="inputNumber" />
                                <div class="randomNum">{{randomNum}}</div>
                            </div>
                            <div v-show="error" style="color:#FD4238">验证码错误</div>
                        </div>
                        <div class="thirdLine">
                            <div class="cancle" @click="popup = false">取消</div>
                            <div class="confirm" @click="changeNumber">确定</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="activeName == '分合历史'">
                <div class="history" id="diagramTableHandle">
                    <el-table :data="tableData_handle" header-cell-class-name="header-cell-style"
                        header-row-class-name="header-row-style" cell-class-name="cell-style" row-class-name="row-style"
                        stripe height="100%" style="width: 100%; height:100%">
                        <el-table-column align="center" prop="updateTime" label="发生时间">
                        </el-table-column>
                        <el-table-column align="center" prop="eventType" label="事件类型">
                        </el-table-column>
                        <el-table-column align="center" prop="userName" label="操作人员">
                        </el-table-column>
                        <el-table-column align="center" prop="eventStatus" label="操作结果">
                        </el-table-column>
                        <template v-slot:empty>
                            <img :src="require('../../assets/img/not_found_data.png')">
                        </template>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        GET_AREAS,
        GET_AREA_LOOPS,
        EXTREMUM_VALUES,
        GetSwitchingClosing,
        PostSwitchingClosing,
    } from '../../api/common'
    import {
        dateFormat,
    } from "@/util/DateUtil"
    import {
        floatFormat
    } from "@/util/MathUtil"

    import {
        publishByLoopUrl
    } from "@/mqtt/control";

    import CircleLoad from './CircleLoad.vue'


    export default {
        name: "LoopDetail",
        props: ['width', 'height', 'loopUrl', 'tab', 'currentLoop'],
        components: {
            CircleLoad
        },
        data() {
            return {
                areaId: 21,
                loopsIdArr: [],
                activeName: this.tab || '电力数据',

                extremNodes: ['Ua', 'Ub', 'Uc', 'Ia', 'Ib', 'Ic', "PA", "PR", "P", "PF", "U_unbl", "I_unbl"],
                requestRes: [],
                nodes: ["Ua", "Ub", "Uc", "Ia", "Ib", "Ic", "PA", "PR", "P", "PF", "U_unbl", "I_unbl"],

                popup: false,

                inputNumber: '',
                randomNum: Math.floor(Math.random() * 9000) + 1000,
                error: false,

                tableData_handle: [],

                circleloadStatus: false,
            }
        },
        computed: {
            tableData() {
                if (this.requestRes.length === 0) {
                    return []
                }
                let data = []
                this.currentLoop.map(l => {
                    this.extremNodes.map(n => {
                        let obj = {}
                        this.requestRes.forEach((res, index) => {
                            obj['loopName'] = l.loopName
                            obj['node'] = this.getChinese(n) + this.getUnit(n)
                            let extremum = res.data.data.extremum;
                            for (let k in extremum) {
                                if (extremum.hasOwnProperty(k)) {
                                    var start = k.indexOf("/");
                                    var s = k.substring(start + 1);
                                    extremum[s] = extremum[k]
                                }
                            }
                            // console.log(extremum)
                            if (typeof (extremum) == 'undefined')
                                return []
                            // console.log(extremum[`${l.subLoopUrl}_${n}`])
                            if (extremum[`${l.subLoopUrl}_${n}`]) {
                                if (index === 0) {
                                    obj['max'] = floatFormat(extremum[`${l.subLoopUrl}_${n}`]
                                        .max, 3)
                                    obj['max_time'] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                                if (index === 1) {
                                    obj['min'] = floatFormat(extremum[`${l.subLoopUrl}_${n}`]
                                        .min, 3)
                                    obj['min_time'] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                            } else {
                                if (index === 0) {
                                    obj['max'] = '--'
                                    obj['max_time'] = '--'
                                }
                                if (index === 1) {
                                    obj['min'] = '--'
                                    obj['min_time'] = '--'
                                }
                            }
                            obj['realValue'] = this.$store.getters.mqttVal(
                                    `${l.subLoopUrl}/${n}`) == undefined ? '--' :
                                parseFloat(Number(this.$store.getters.mqttVal(
                                    `${l.subLoopUrl}/${n}`)).toFixed(2))
                        })
                        data.push(obj)
                    })
                })
                return this.$store.getters.projectId == 4 ? data.filter(item => item.node.indexOf('不平衡度') == -1) : data
            },
            errorstatus() {
                if (this.$store.getters.mqttVal(`${this.currentLoop[0].errorStatus}`) == 'True' ||
                    this.$store.getters.mqttVal(`${this.currentLoop[0].errorStatus}`) == 1) {
                    return true
                } else {
                    return false
                }
            },
            state() {
                if (
                    this.$store.getters.mqttVal(`${this.currentLoop[0].switchStatus}`) == 0 ||
                    this.$store.getters.mqttVal(`${this.currentLoop[0].switchStatus}`) == 'False'
                ) {
                    return '分闸'
                } else if (
                    this.$store.getters.mqttVal(`${this.currentLoop[0].switchStatus}`) == 1 ||
                    this.$store.getters.mqttVal(`${this.currentLoop[0].switchStatus}`) == 'True'
                ) {
                    return '合闸'
                } else {
                    return '--'
                }
            },
            distantstatus() {
                if (this.$store.getters.mqttVal(`${this.currentLoop[0].distantStatus}`) == 'True' ||
                    this.$store.getters.mqttVal(`${this.currentLoop[0].distantStatus}`) == 1) {
                    return '远方'
                } else if (this.$store.getters.mqttVal(`${this.currentLoop[0].distantStatus}`) == 'False' ||
                    this.$store.getters.mqttVal(`${this.currentLoop[0].distantStatus}`) == 0) {
                    return '就地'
                } else {
                    return '--'
                }
            }
        },
        created() {
            GET_AREAS().then(res => {
                this.areaId = res.data.data.areas[0].areaId
                this.loopsIdArr = [this.currentLoop[0].loopId]
                this.requestValues()
                this.getSwitchingClosing()
            })
        },
        methods: {
            handleClick(value) {
                if (value) {
                    this.popup = true
                    this.error = false
                    this.inputNumber = ''
                    this.randomNum = Math.floor(Math.random() * 9000) + 1000
                }
            },
            getSwitchingClosing() {
                GetSwitchingClosing(this.currentLoop[0].loopId).then(res => {
                    let data = []
                    res.data.data.switchEventList.forEach((item, index) => {
                        data.push({
                            updateTime: dateFormat("YYYY年mm月dd日 HH:MM:SS", new Date(item
                                .updateTime)),
                            eventType: item.eventType == 'opened' ? '分闸' : '合闸',
                            userName: item.userName,
                            eventStatus: item.eventStatus == 0 ? '操作失败' : item.eventStatus ==
                                1 ? '操作成功' : '正在获取数据'
                        })
                    })
                    this.tableData_handle = data
                })
            },
            timeGenerate(time) {
                let date = new Date(time);
                return dateFormat("HH:MM:SS", date)
            },
            async requestValues() {
                this.requestRes = []
                if (this.loopsIdArr.length === 0 || this.extremNodes.length === 0) {
                    return
                }
                let res = []
                try {
                    res = await Promise.all([
                        EXTREMUM_VALUES(this.loopsIdArr, this.extremNodes, "MAX", new Date()),
                        EXTREMUM_VALUES(this.loopsIdArr, this.extremNodes, "MIN", new Date()),
                    ])
                } catch (e) {

                } finally {
                    this.requestRes = res
                    return res
                }
            },
            getUnit(n) {
                if (n == 'Ua' || n == 'Ub' || n == 'Uc') {
                    return '(V)'
                } else if (n == 'Ia' || n == 'Ib' || n == 'Ic') {
                    return '(A)'
                } else if (n == 'U_unbl' || n == 'I_unbl') {
                    return '(%)'
                } else if (n == 'PA') {
                    return '(W)'
                } else if (n == 'PR') {
                    return '(var)'
                } else if (n == 'P') {
                    return '(VA)'
                } else {
                    return ''
                }
            },
            getChinese(n) {
                switch (n) {
                    case 'Ua':
                        return 'A相电压'
                    case 'Ub':
                        return 'B相电压'
                    case 'Uc':
                        return 'C相电压'
                    case 'Ia':
                        return 'A相电流'
                    case 'Ib':
                        return 'B相电流'
                    case 'Ic':
                        return 'C相电流'
                    case 'P':
                        return '有功功率'
                    case 'PR':
                        return '无功功率'
                    case 'PA':
                        return '视在功率'
                    case 'PF':
                        return '功率因数'
                    case 'U_unbl':
                        return '电压不平衡度'
                    case 'I_unbl':
                        return '电流不平衡度'
                    default:
                        return ''
                }
            },
            changeNumber() {
                // console.log(new Date());
                if (this.inputNumber == this.randomNum) {
                    this.error = false
                    this.popup = false

                    // to do
                    // 向mqtt推数据
                    // 判断数据是否推送成功，如果成功，向数据库添加记录
                    // 重新获取分合记录


                    let ss = this.$store.getters.mqttVal(`${this.currentLoop[0].switchStatus}`)
                    let currentstate = ''
                    if (this.state == '合闸') {
                        currentstate = 'opened'
                        // console.log(this.currentLoop[0]);
                        publishByLoopUrl(this.currentLoop[0].switchOff.split('/')[0],
                            `${this.currentLoop[0].switchOff.split('/').slice(-4).join('/')}`,
                            '1')
                        PostSwitchingClosing(currentstate, this.currentLoop[0].loopId).then((res) => {
                            this.getSwitchingClosing()
                        })
                        let num = 0
                        let timer = setInterval(() => {
                            this.getSwitchingClosing()
                            if (num > 9) {
                                clearInterval(timer)
                            }
                            num++
                        }, 5000)
                    } else if (this.state == '分闸') {
                        currentstate = 'closed'
                        // console.log(this.currentLoop[0]);
                        publishByLoopUrl(this.currentLoop[0].switchOn.split('/')[0],
                            `${this.currentLoop[0].switchOn.split('/').slice(-4).join('/')}`,
                            '1')
                        PostSwitchingClosing(currentstate, this.currentLoop[0].loopId).then((res) => {
                            this.getSwitchingClosing()
                        })
                        let num = 0
                        let timer = setInterval(() => {
                            this.getSwitchingClosing()
                            if (num > 9) {
                                clearInterval(timer)
                            }
                            num++
                        }, 5000)
                    }
                    this.circleloadStatus = true

                    let num = 0
                    let timer = setInterval(() => {
                        num++
                        if (this.$store.getters.mqttVal(`${this.currentLoop[0].switchStatus}`) !== ss || num >
                            5) {
                            this.circleloadStatus = false
                            clearInterval(timer)
                        }
                        // if (this.$store.getters.mqttVal(`${this.currentLoop[0].switchStatus}`) !== ss) {
                        //     PostSwitchingClosing(currentstate, this.currentLoop[0].loopId).then((res) => {
                        //         this.$message({
                        //             message: '发送成功',
                        //             type: 'success'
                        //         });

                        //         this.getSwitchingClosing()
                        //     });
                        // } else {
                        //     this.$message.error('发送失败');
                        // }
                    }, 1000)
                } else {
                    this.error = true
                }
            },
        }
    };
</script>

<style lang="less" scoped>
.bg{
 &::before{
            content: '';
            position:fixed;
            top:0;
            left: 0;
            height: 100%;
            width: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 99;
        }
}
    /deep/.detailBody {
        .w(880);
        // .h(640);
        min-height: 550rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        opacity: 1;
        overflow-y: hidden;
        z-index: 101;
        transition: all 0.5s;
        .el-tabs{
            margin-top: 0 !important;
        }
        .el-tabs__nav{
            float: left !important;
        }
        .el-tabs__header{
            position: relative !important;
        }
        .title {
            width: 100%;
            .h(65);
            padding: 0 240/192vw;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            font-size: 18rem;
            font-weight: bold;
            color: #333333;

            img {
                cursor: pointer;
            }
        }

        .tab {
            border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            padding: 0 240/192vw;
            overflow: hidden;
        }

        .table {
            width: 100%;
            // height: 55vh;
            min-height: 450rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            //火狐隐藏滚动条
            scrollbar-width: none;

            ::-webkit-scrollbar {
                display: none;
            }
        }
    }

    .pagination {
        height: 6vh;
        .w(300);
        align-self: flex-end;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        font-size: 14rem;

        .button {
            .w(74);
            .h(24);
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 2px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    .control {
        .w(500);
        .h(300);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 22rem;

        .circleload {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;
        }


        .state {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-evenly;
            align-items: center;

            .control_btn {
                width: 96rem;
                height: 40rem;
                background: #0D94FF;
                font-size: 18rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                cursor: pointer;
            }
        }
    }

    .popup {
        width: 528rem;
        height: 248rem;
        background: #FFFFFF;
        box-shadow: 0px 4px 40px 0px rgba(0, 43, 102, 0.28);
        border-radius: 2px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .firstLine {
            width: 85%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            margin-left: 32rem;

            .icon {
                width: 22rem;
                height: 22rem;
                margin-right: 17rem;
                margin-top: 5.5rem;
            }
        }

        .secondLine {
            height: 50rem;
            font-size: 16rem;
            color: #999;
            margin-left: 70rem;

            input {
                border-bottom: 1rem solid #ccc;
                width: 56rem;
                margin: 0 8rem;
            }

            .randomNum {
                width: 56rem;
                background: #EEEEEE;
                border-radius: 4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #666;
            }
        }

        .thirdLine {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            font-size: 14rem;

            .cancle {
                width: 60rem;
                height: 32rem;
                border: 1px solid rgba(0, 0, 0, 0.15);
                border-radius: 2rem;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                color: #333;
                cursor: pointer;
            }

            .confirm {
                width: 60rem;
                height: 32rem;
                background: #0D94FF;
                border-radius: 2rem;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                color: #fff;
                margin-left: 8rem;
                margin-right: 32rem;
                cursor: pointer;
            }
        }
    }

    .history {
        width: 100%;
        .h(520);
    }
</style>